<template>
  <Dialog
    :model-value="visible"
    :title="title"
    dialog-type="error"
    dialog-size="small"
    :show-close="true"
    :close-on-overlay="!loading"
    @update:model-value="(val) => { if (!val) handleClose() }"
    @close="handleClose"
  >
    <div class="unsaved-dialog" :class="{ 'is-loading': loading }">
      <div class="dialog-content">
        <p class="dialog-message">{{ message }}</p>
        <p v-if="loading" class="loading-text">{{ loadingText }}</p>
      </div>
    </div>

    <template #footer>
      <div class="footer-actions">
        <ResponsiveButton
          button_type="outlined"
          built_in_theme="error"
          size="medium"
          :disabled="loading"
          @click-button="handleClose"
        >
          {{ cancelLabel }}
        </ResponsiveButton>
        <div class="confirm-actions">
          <ResponsiveButton
            button_type="filled"
            built_in_theme="error"
            size="medium"
            :disabled="loading"
            @click-button="handleDiscard"
          >
            {{ discardLabel }}
          </ResponsiveButton>
          <ResponsiveButton
            button_type="filled"
            built_in_theme="dark"
            size="medium"
            :disabled="loading"
            @click-button="handleSave"
          >
            {{ saveLabel }}
          </ResponsiveButton>
        </div>
      </div>
    </template>
  </Dialog>
</template>

<script>
export default {
  name: 'UnsavedChangesDialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Unsaved Changes',
    },
    message: {
      type: String,
      default: 'You have unsaved changes. Save before leaving this page?',
    },
    cancelLabel: {
      type: String,
      default: 'Cancel',
    },
    discardLabel: {
      type: String,
      default: 'Discard',
    },
    saveLabel: {
      type: String,
      default: 'Save Changes',
    },
    modalClass: {
      type: String,
      default: 'unsaved-changes-dialog',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    loadingText: {
      type: String,
      default: 'Saving changes...',
    },
  },
  emits: ['update:modelValue', 'save', 'discard', 'cancel'],
  computed: {
    visible: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      },
    },
  },
  methods: {
    handleClose() {
      if (this.loading) return;
      this.visible = false;
      this.$emit('cancel');
    },
    handleDiscard() {
      if (this.loading) return;
      this.$emit('discard');
    },
    handleSave() {
      if (this.loading) return;
      this.$emit('save');
    },
  },
};
</script>

<style scoped>
.unsaved-dialog {
  width: 100%;
  height: 100%;
}

.dialog-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f9fbfd;
  padding: 24px 32px 12px;
  text-align: center;
  gap: 12px;
}

.header-icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dialog-message {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: #374957;
  line-height: 28px;
  margin: 0;
  text-align: center;
  width: 100%;
}

.loading-text {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #1e4670;
  line-height: 20px;
  margin: 0;
}

.footer-actions {
  display: flex;
  gap: 12px;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.confirm-actions {
  display: flex;
  gap: 12px;
  margin-left: auto;
}

.is-loading {
  opacity: 0.85;
}
</style>
